import { React, useState, useEffect } from 'react';

import NavBarMobile from '../components/NavBarMobile'
import CharNameMobile from '../components/CharNameMobile.js'
import RulesWindow from '../components/RulesWindow'
import HelpWindow from '../components/HelpWindow'
import MobileSpellDetail from '../components/MobileSpellDetail'
import Help from '../components/Help'
import MobileDataPage from './MobileDataPage.js'
import AllSpells from '../components/AllSpells'
import sample_data_flat from '../components/Charsheet0/helpers/sample_data_flat.js'

import Image01 from '../pdf/CombatActions.jpg'

import './MobileHome.css'



function MobileHome(props) {


  // ------------- VARIABLES -------------

  const activeViewArray = useState("charsheet")
  const numCharsArray = useState(1)
  const [rulesWindowSrc, setRulesWindowSrc ] = useState( { title: 'Combat Actions', source: Image01 } )

  const globalState = props.state;
  const layout = globalState[3];

  // ------------- RETURN JSX -------------

  return (

  <div id='main-app-mobile'>
  
    <NavBarMobile {...props} setRule={ setRulesWindowSrc } activeViewArray={activeViewArray} numCharsArray={numCharsArray} className="no-print" />

    <RulesWindow {...props} src={ rulesWindowSrc } />

    <HelpWindow {...props} />

    <MobileDataPage {...props} charID='charMobile' activeViewArray={activeViewArray} numCharsArray={numCharsArray} />

    <AllSpells {...props} UItype='mobile'/>

    <MobileSpellDetail {...props} />

    <Help />

    <div id="footer-mobile"><b>Advanced Dungeon Master</b><br />by DXA Development</div>
    
  </div>
  )
}

export default MobileHome